import request from '../utils/request.js'

// 获取医生在班
export function getWorkStaffByDate(params) {
    return request({
        url: '/doctor-service/schedule/getWorkStaffByDate',
        method: 'get',
        params,
        headers: {
            "content-type": "application/json",
        },
    })
}

// 新增预约
export function saveSubscribe(data) {
    return request({
        url: '/user-service/ewechat/ask/apptAsk',
        method: 'post',
        data,
        headers: {
            "content-type": "application/json",
        },
    })
}

// 修改预约
export function editSubscribe(data) {
    return request({
        url: '/user-service/doctormg/askinfo/modifyAppt',
        method: 'post',
        data,
        headers: {
            "content-type": "application/json",
        },
    })
}

// 预约详情
export function getSubscribeInfo(params) {
    return request({
        url: '/user-service/app/askinfo/getByAskNo',
        method: 'get',
        params,
        headers: {
            "content-type": "application/json",
        },
    })
}

// 取消
export function cancelSubscribe(data) {
    return request({
        url: `/user-service/doctormg/askinfo/userEndAsk/${data.askNo}`,
        method: 'put',
        data: {
            reason: '替患者主动取消问诊预约'
        },
        headers: {
            "content-type": "application/json",
        },
    })
}
